import {
  ThreeDotMenu as ThreeDotMenuImpl,
  ThreeDotMenuItem,
  ThreeDotMenuProps,
} from '@mm/components';
import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import {
  combinedFeatureFlagsSelector,
  getNextBillingTypeForFeature,
} from '@mm/state/selectors/featureFlagsSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { useSelector } from 'react-redux';
import { PlanBadge } from '../ProBadge';
import './ThreeDotMenu.scss';

export type MenuItem = Omit<ThreeDotMenuItem, 'children'> & {
  requiredFeature?: SubscriptionFeatureFlag;
};
export type Props = Omit<ThreeDotMenuProps, 'elements'> & {
  elements: MenuItem[];
};

export const ThreeDotMenu = ({
  elements: elementsFromProps,
  ...restProps
}: Props) => {
  const features = useSelector(combinedFeatureFlagsSelector);
  const featuresForPlans = useSelector(
    (state: StoreState) => state.featureFlags.featuresForPlans,
  );

  const elements: ThreeDotMenuItem[] = elementsFromProps.map(element => {
    const { requiredFeature } = element;

    const billingType = getNextBillingTypeForFeature(
      features,
      featuresForPlans,
      requiredFeature,
    );

    const children = billingType ? (
      <PlanBadge
        className="three-dot-menu__drop-down_list-item-badge"
        billingType={billingType}
        size={10}
      />
    ) : undefined;

    return { ...element, children };
  });

  return <ThreeDotMenuImpl {...restProps} elements={elements} />;
};
